// extracted by mini-css-extract-plugin
export default {"vk":"ViberBlock_vk__1z46+","logo":"ViberBlock_logo__Odd57","info":"ViberBlock_info__ybJeY","subscribe":"ViberBlock_subscribe__gLYPN"};